import styled from 'styled-components';

const Sticky = styled.div`
  display: flex;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 99;
`;

export default Sticky;
